(function () {
  'use strict';

  const CONFIG = {
    store:   window.Shopify ? window.Shopify.shop : 'demo.myshopify.com',
    version: '3.2.1',
    debug:   true
  };

  const state = {
    pageType:  detectPageType(),
    startTime: Date.now(),
    sessionId: generateId(),
    events:    [],
    issues:    [],
    metrics:   { lcp: null, cls: null, inp: null, ttfb: null }
  };

  function generateId() {
    return 'xxxxxxxx'.replace(/x/g, () => (Math.random() * 16 | 0).toString(16));
  }

  function detectPageType() {
    const path = window.location.pathname;
    if (path === '/')                    return 'home';
    if (path.includes('/products/'))     return 'product';
    if (path.includes('/collections/'))  return 'collection';
    if (path.includes('/cart'))          return 'cart';
    if (path.includes('/blogs/'))        return 'blog';
    if (path.includes('/pages/'))        return 'page';
    return 'other';
  }

  function log(...args) {
    console.log('[AI Agency]', ...args);
  }

  /* ── AGENT 1: SEO ── */
  const SEOAgent = {
    init() {
      log('SEO Agent: Starting...');
      this.auditPage();
      this.optimiseMetaTags();
      this.checkCanonical();
      this.injectBreadcrumbSchema();
      log('SEO Agent: Done');
    },

    auditPage() {
      const title = document.title;
      if (!title || title.length < 10)
        state.issues.push({ type: 'seo', severity: 'high', msg: 'Page title missing or too short' });

      const metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc || !metaDesc.content)
        state.issues.push({ type: 'seo', severity: 'high', msg: 'Meta description missing' });

      const h1s = document.querySelectorAll('h1');
      if (h1s.length === 0)
        state.issues.push({ type: 'seo', severity: 'high', msg: 'No H1 tag found' });

      const imgs = document.querySelectorAll('img');
      let missingAlt = 0;
      imgs.forEach(img => { if (!img.alt) missingAlt++; });
      if (missingAlt > 0) {
        state.issues.push({ type: 'seo', severity: 'medium', msg: missingAlt + ' images missing alt text - auto-fixing' });
        this.autoFixAltText(imgs);
      }
    },

    autoFixAltText(imgs) {
      imgs.forEach(img => {
        if (img.alt) return;
        const src = img.src || '';
        const filename = src.split('/').pop().split('?')[0].replace(/[-_]/g, ' ').replace(/\.[^/.]+$/, '');
        const nearby = img.closest('a,div,article');
        const nearbyText = nearby ? nearby.querySelector('h1,h2,h3,h4,p') : null;
        const alt = nearbyText ? nearbyText.textContent.trim().slice(0, 100) : filename || 'Product image';
        img.setAttribute('alt', alt);
        img.setAttribute('data-ai-alt', 'true');
      });
    },

    optimiseMetaTags() {
      const tags = [
        ['og:type', state.pageType === 'product' ? 'product' : 'website'],
        ['og:url',  window.location.href],
        ['og:site_name', document.title]
      ];
      tags.forEach(function(item) {
        const prop = item[0];
        const content = item[1];
        if (!document.querySelector('meta[property="' + prop + '"]')) {
          const m = document.createElement('meta');
          m.setAttribute('property', prop);
          m.setAttribute('content', content);
          m.setAttribute('data-ai', 'true');
          document.head.appendChild(m);
        }
      });
    },

    checkCanonical() {
      if (!document.querySelector('link[rel="canonical"]')) {
        const link = document.createElement('link');
        link.rel = 'canonical';
        link.href = window.location.origin + window.location.pathname;
        link.setAttribute('data-ai', 'true');
        document.head.appendChild(link);
        log('SEO Agent: Canonical tag added');
      }
    },

    injectBreadcrumbSchema() {
      const breadcrumb = document.querySelector('.breadcrumb, [aria-label*="breadcrumb"]');
      if (!breadcrumb) return;
      const items = breadcrumb.querySelectorAll('a');
      if (!items.length) return;
      const schema = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: Array.from(items).map(function(a, i) {
          return { '@type': 'ListItem', position: i + 1, name: a.textContent.trim(), item: a.href };
        })
      };
      const s = document.createElement('script');
      s.type = 'application/ld+json';
      s.textContent = JSON.stringify(schema);
      document.head.appendChild(s);
    }
  };

  /* ── AGENT 2: PERFORMANCE ── */
  const PerformanceAgent = {
    init() {
      log('Performance Agent: Starting...');
      this.measureWebVitals();
      this.optimiseLazyLoading();
      this.prefetchOnHover();
      log('Performance Agent: Done');
    },

    measureWebVitals() {
      if (!('PerformanceObserver' in window)) return;
      try {
        new PerformanceObserver(function(list) {
          const entries = list.getEntries();
          state.metrics.lcp = Math.round(entries[entries.length - 1].startTime);
          log('Performance Agent: LCP = ' + state.metrics.lcp + 'ms');
        }).observe({ type: 'largest-contentful-paint', buffered: true });

        let clsValue = 0;
        new PerformanceObserver(function(list) {
          list.getEntries().forEach(function(e) {
            if (!e.hadRecentInput) clsValue += e.value;
          });
          state.metrics.cls = Math.round(clsValue * 1000) / 1000;
        }).observe({ type: 'layout-shift', buffered: true });
      } catch(e) {}

      window.addEventListener('load', function() {
        const nav = performance.getEntriesByType('navigation')[0];
        if (nav) {
          state.metrics.ttfb = Math.round(nav.responseStart - nav.requestStart);
          log('Performance Agent: TTFB = ' + state.metrics.ttfb + 'ms');
        }
      });
    },

    optimiseLazyLoading() {
      const vp = window.innerHeight;
      document.querySelectorAll('img:not([loading])').forEach(function(img) {
        const rect = img.getBoundingClientRect();
        if (rect.top > vp * 1.2) {
          img.loading = 'lazy';
          img.decoding = 'async';
        }
      });
      document.querySelectorAll('iframe:not([loading])').forEach(function(f) {
        f.loading = 'lazy';
      });
      log('Performance Agent: Lazy loading applied');
    },

    prefetchOnHover() {
      const prefetched = new Set();
      document.addEventListener('mouseover', function(e) {
        const link = e.target.closest('a');
        if (!link || !link.href) return;
        if (!link.href.startsWith(window.location.origin)) return;
        if (prefetched.has(link.href)) return;
        prefetched.add(link.href);
        const pf = document.createElement('link');
        pf.rel = 'prefetch';
        pf.href = link.href;
        document.head.appendChild(pf);
      }, { passive: true });
    }
  };

  /* ── AGENT 3: UX ── */
  const UXAgent = {
    scrollDepth: 0,
    rageclicks:  0,

    init() {
      log('UX Agent: Starting...');
      this.trackScrollDepth();
      this.trackRageClicks();
      this.checkMobileTapTargets();
      log('UX Agent: Done');
    },

    trackScrollDepth() {
      const self = this;
      window.addEventListener('scroll', function() {
        const depth = Math.round((window.scrollY + window.innerHeight) / document.body.scrollHeight * 100);
        if (depth > self.scrollDepth) self.scrollDepth = depth;
      }, { passive: true });
    },

    trackRageClicks() {
      const self = this;
      let last = { x: 0, y: 0, t: 0 };
      document.addEventListener('click', function(e) {
        const now = Date.now();
        if (Math.abs(e.clientX - last.x) < 20 && Math.abs(e.clientY - last.y) < 20 && now - last.t < 500) {
          self.rageclicks++;
          if (self.rageclicks >= 3) {
            state.issues.push({ type: 'ux', severity: 'medium', msg: 'Rage clicks detected on page' });
            self.rageclicks = 0;
          }
        }
        last = { x: e.clientX, y: e.clientY, t: now };
      });
    },

    checkMobileTapTargets() {
      if (window.innerWidth > 768) return;
      let small = 0;
      document.querySelectorAll('a, button').forEach(function(el) {
        const r = el.getBoundingClientRect();
        if (r.width < 44 || r.height < 44) small++;
      });
      if (small > 0)
        state.issues.push({ type: 'ux', severity: 'medium', msg: small + ' tap targets too small on mobile' });
      log('UX Agent: Mobile check complete - ' + small + ' small targets found');
    }
  };

  /* ── AGENT 4: CRO ── */
  const CROAgent = {
    init() {
      log('CRO Agent: Starting...');
      this.injectTrustSignals();
      this.addUrgencyIfLowStock();
      this.trackAddToCart();
      log('CRO Agent: Done');
    },

    injectTrustSignals() {
      if (state.pageType !== 'product') return;
      if (document.querySelector('[data-ai-trust]')) return;
      const priceBlock = document.querySelector('.price, .product__price, [data-product-price]');
      if (!priceBlock) return;
      const trust = document.createElement('div');
      trust.setAttribute('data-ai-trust', 'true');
      trust.style.cssText = 'display:flex;gap:14px;flex-wrap:wrap;margin:10px 0;font-size:12px;color:#555;';
      trust.innerHTML = '<span>🔒 Secure checkout</span><span>↩ 30-day returns</span><span>🚚 Free shipping</span><span>🛡 Warranty included</span>';
      priceBlock.parentNode.insertBefore(trust, priceBlock.nextSibling);
      log('CRO Agent: Trust signals injected');
    },

    addUrgencyIfLowStock() {
      if (state.pageType !== 'product') return;
      const stockEl = document.querySelector('[data-inventory-remaining], .product__inventory');
      if (!stockEl) return;
      const count = parseInt(stockEl.textContent);
      if (count > 0 && count <= 5) {
        const urgency = document.createElement('p');
        urgency.style.cssText = 'color:#c0392b;font-size:13px;font-weight:600;margin:6px 0;';
        urgency.textContent = 'Only ' + count + ' left in stock';
        stockEl.parentNode.insertBefore(urgency, stockEl);
      }
    },

    trackAddToCart() {
      document.addEventListener('click', function(e) {
        if (e.target.closest('button[name="add"], [data-add-to-cart]')) {
          state.events.push({ type: 'add_to_cart', t: Date.now() });
          log('CRO Agent: Add to cart tracked');
        }
      });
    }
  };

  /* ── AGENT 5: TECH MAINTENANCE ── */
  const TechAgent = {
    init() {
      log('Tech Agent: Starting...');
      this.monitorJSErrors();
      this.monitorSlowResources();
      log('Tech Agent: Monitoring active');
    },

    monitorJSErrors() {
      window.addEventListener('error', function(e) {
        state.issues.push({ type: 'tech', severity: 'high', msg: 'JS Error: ' + e.message });
        log('Tech Agent: JS error caught - ' + e.message);
      });
      window.addEventListener('unhandledrejection', function(e) {
        state.issues.push({ type: 'tech', severity: 'medium', msg: 'Promise rejection: ' + e.reason });
      });
    },

    monitorSlowResources() {
      window.addEventListener('load', function() {
        performance.getEntriesByType('resource').forEach(function(r) {
          if (r.duration > 2000) {
            state.issues.push({ type: 'tech', severity: 'medium', msg: 'Slow resource: ' + r.name.split('/').pop() + ' (' + Math.round(r.duration) + 'ms)' });
          }
        });
        log('Tech Agent: Resource audit complete');
      });
    }
  };

  /* ── AGENT 6: IMAGE OPTIMISATION ── */
  const ImageAgent = {
    init() {
      log('Image Agent: Starting...');
      this.upgradeToWebP();
      this.addSizeHints();
      log('Image Agent: Done');
    },

    upgradeToWebP() {
      document.querySelectorAll('img[src*="cdn.shopify.com"]').forEach(function(img) {
        function upgrade(src) {
          if (!src || src.includes('format=webp')) return src;
          return src + (src.includes('?') ? '&' : '?') + 'format=webp&quality=85';
        }
        img.src = upgrade(img.src);
        if (img.srcset) {
          img.srcset = img.srcset.split(',').map(function(s) {
            const parts = s.trim().split(' ');
            return upgrade(parts[0]) + (parts[1] ? ' ' + parts[1] : '');
          }).join(',');
        }
      });
      log('Image Agent: WebP applied to all Shopify CDN images');
    },

    addSizeHints() {
      document.querySelectorAll('img:not([width]):not([height])').forEach(function(img) {
        img.addEventListener('load', function() {
          if (!img.width)  img.width  = img.naturalWidth;
          if (!img.height) img.height = img.naturalHeight;
        }, { once: true });
      });
    }
  };

  /* ── AGENT 7: ANALYTICS ── */
  const AnalyticsAgent = {
    sessionStart: Date.now(),

    init() {
      log('Analytics Agent: Starting...');
      this.trackEngagement();
      this.reportOnExit();
      log('Analytics Agent: Tracking active');
    },

    trackEngagement() {
      [10, 30, 60, 120].forEach(function(secs) {
        setTimeout(function() {
          state.events.push({ type: 'time_on_page', seconds: secs, page: state.pageType });
          log('Analytics Agent: ' + secs + 's milestone on ' + state.pageType);
        }, secs * 1000);
      });
    },

    reportOnExit() {
      const self = this;
      document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'hidden') {
          const summary = {
            duration:    Math.round((Date.now() - self.sessionStart) / 1000),
            scrollDepth: UXAgent.scrollDepth,
            events:      state.events.length,
            issues:      state.issues.length,
            metrics:     state.metrics
          };
          log('Analytics Agent: Session ended', summary);
        }
      });
    }
  };

  /* ── ORCHESTRATOR ── */
  const Orchestrator = {
    agents: [SEOAgent, PerformanceAgent, UXAgent, CROAgent, TechAgent, ImageAgent, AnalyticsAgent],

    init() {
      log('========================================');
      log('AI Agency Engine v' + CONFIG.version);
      log('Store: ' + CONFIG.store);
      log('Page: ' + state.pageType);
      log('Session: ' + state.sessionId);
      log('========================================');

      const self = this;
      this.agents.forEach(function(agent, i) {
        setTimeout(function() {
          try {
            agent.init();
          } catch(e) {
            console.warn('[AI Agency] Agent failed:', e);
          }
        }, i * 100);
      });

      window.__AI_AGENCY__ = {
        getState:   function() { return state; },
        getIssues:  function() { return state.issues; },
        getMetrics: function() { return state.metrics; },
        version:    CONFIG.version,
        store:      CONFIG.store
      };

      log('All agents running. Type window.__AI_AGENCY__.getState() to inspect.');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { Orchestrator.init(); });
  } else {
    Orchestrator.init();
  }

})();